export async function downloadFile(url: string, fileName: string) {
  try {
    // 1. Fetch the file data
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok');
    
    // 2. Convert to blob
    const blob = await response.blob();
    
    // 3. Create a local URL for the blob
    const blobUrl = window.URL.createObjectURL(blob);
    
    // 4. Create a hidden anchor element
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
    
    // 5. Append to body, click, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    
    return true;
  } catch (error) {
    console.error('Download failed:', error);
    // Fallback: Just open in new tab if blob download fails
    window.open(url, '_blank');
    return false;
  }
}
